<div class="relative w-full overflow-hidden aarni-font mt-[80px]">
    <div class="relative w-full h-[80vh]">
        <div *ngFor="let img of images; let i = index"
             [class.opacity-100]="i === currentIndex"
             [class.opacity-0]="i !== currentIndex"
             class="absolute inset-0 w-full h-full duration-1000 ease-in-out">
            <img [src]="img.image"
                 class="object-cover w-full h-full"
                 [alt]="img.title">
        </div>
    </div>
    <div class="absolute top-0 left-0 w-full h-[80vh]  flex items-center justify-center">
        <div class="text-center text-white p-4 max-w-2xl">
            <div [innerHTML]="images[currentIndex].description">
                {{ images[currentIndex].description }}
            </div>
            <button
                class="rounded-2xl font-semibold py-2 px-6 mt-4 hover:shadow hover:shadow-green-50 hover:text-green-900 transition text-black bg-white"
                [routerLink]="'/form/apply-form'">
                Apply now
            </button>
            <div class="flex justify-center absolute bottom-5 left-[50%] pt-5 gap-4">
                <div class="flex gap-3 items-center">
                    <button *ngFor="let img of images; let i = index"
                            (click)="slide(i)"
                            [class]="'w-3 h-3 rounded-full transition-colors ' +
                                    (i === currentIndex ? 'bg-white' : 'bg-white/50')">
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div>
    <div class="max-w-7xl container mx-auto p-6 aarni-font">
        <div class="md:flex hidden space-x-4  my-4 border-2 border-gray-200 rounded-full justify-center">
            <ng-container *ngFor="let item of menus">
                <a
                    (click)="scrollToSection(item.id)"
                    class="tab-link text-gray-500 font-medium hover:text-green-400 hover:border-b-2 py-4 hover:border-green-400 cursor-pointer"
                    [ngClass]="{ ' text-green-600': item.id === activeMenuId }"
                >
                    {{ item.label }}
                </a>
            </ng-container>
        </div>
    </div>
</div>

<section id="overview" class="scroll-mt-24 aarni-font">
    <div class="max-w-7xl mx-auto p-6">
        <h4 class="text-xl font-bold mb-2 ">Overview</h4>
        <p class="my-2 text-gray-800 text-justify">Situated in Himachal Pradesh, ARNI University is an academic institution
            that provides excellence in education and an environment for holistic development. ARNI University is
            accredited by the University Grants Commission (UGC) and offers a diverse range of programs across many
            disciplines, including Engineering, Management, Agriculture, and Humanities. With state-of-the-art
            infrastructure, experienced faculty, and a combined theoretical and practical knowledge-based curriculum, we
            are committed to providing the best education.
        </p>
        <p class="my-2 text-gray-800 text-justify">At ARNI University, we take pride in developing scholars globally. Our
            Campus is rich in diversity, following multicultural lifestyles, providing an environment based on respect
            and understanding for one another. Given the dynamic practices of research, innovation, and community social
            responsibility that we embrace, the University expects its students to develop critical thinking and
            rational decision-making skills that will enable them to make valuable contributions to society. Our
            partnerships with various industries and institutions provide students with ample opportunities for
            internships, projects, and placements, ensuring they are well-equipped for the challenges of the global
            workforce.
        </p>
        <p class="my-2 text-gray-800 text-justify">
            An educational experience at ARNI University is a unique journey where students idealize their ability to
            assimilate knowledge, skills, and values that will not only allow them to be successful in their profession
            but also make meaningful contributions to their communities and look to improvement wherever positive change
            can be recognized.
        </p>
        <div class="grid md:grid-cols-2 py-6 gap-4">
            <div>
                <h4 class="text-xl font-bold mb-2 ">Why Choose India for Higher Education</h4>
                <ul class="list-disc pl-5 space-y-2 text-gray-700 text-justify">
                    <li>
                        India is the fastest-developing country and the 5th largest economy in the world. Here, students
                        from all over the world will get an affordable, high-quality education as compared to other
                        Western countries, making it an ideal destination for international students.
                    </li>
                    <li>
                        India offers a wide range of courses across different fields—engineering, medicine, arts,
                        languages, history and culture, business, and finance. Whether you're interested in
                        research-based programs or creative subjects, India has something for every academic interest.
                    <li>
                        India is focused on the concept of Inclusivity! Thus, we offer a curriculum in various regional
                        languages and English, facilitating easier adaptation for international students. The
                        multicultural environment allows students to immerse themselves in a rich tapestry of
                        traditions, cuisines, and festivals.
                    </li>
                    <li>
                        With more than 1000 universities that are approved and recognized by the government bodies,
                        students are enabled to pursue their further studies or employment opportunities globally. The
                        degrees issued by approved universities are globally accepted and recognized.
                    </li>
                    <li>
                        For the ease of international students, more often, Indian Universities and colleges have
                        separate offices to assist international students with admissions, accommodation, and
                        integration into campus life. There are strict rules to avoid any kind of humiliation, racism,
                        or misbehave with students to maintain the academic integrity.
                    </li>
                </ul>

            </div>
            <div>
                <h4 class="text-xl font-bold mb-2 ">How ARNI University Transforms Your Life Through Educational
                    Excellence</h4>
                <ul class="list-disc pl-5 space-y-2 text-gray-700 text-justify">
                    <li>
                        ARNI University offers a global industry-relevant curriculum that is designed and developed in
                        collaboration with industry experts and well-established scholars to ensure students acquire
                        skills and knowledge that meet ongoing market trends.
                    </li>
                    <li>
                        At ARNI University, we possess a team of dedicated educators and researchers who have both
                        academic knowledge and real-world experience, committed to mentoring students and fostering a
                        culture of academic inquiry.
                    </li>
                    <li>
                        ARNI is not just focused on academic excellence; we encourage practical knowledge too. Beyond
                        the textbook, we emphasized extracurricular activities, leadership programs, guest lectures, and
                        community service to develop well-rounded individuals.
                    </li>
                    <li>
                        We offer global opportunities through partnerships and exchange programs, students gain
                        international exposure, broadening their perspectives and enhancing employability. Our campus
                        provides a safe, inclusive, and nurturing environment, ensuring students feel secure.
                    </li>
                    <li>ARNI's dedicated placement cell works tirelessly to connect students with leading organizations
                        for internships and job opportunities. Additionally, assist students in resume building,
                        interview practice, and grooming for better career opportunities.
                    </li>
                </ul>

            </div>
        </div>

    </div>
</section>

<section id="quick-facts" class="scroll-mt-24 bg-gradient-to-r from-indigo-400 to-sky-400 py-10 text-white aarni-font">
    <div class="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        <div>
            <p class="text-4xl font-bold">20+</p>
            <p class="text-lg font-semibold">Diverse Nationalities Represented on Campus</p>
        </div>
        <div>
            <p class="text-4xl font-bold">200+</p>
            <p class="text-lg font-semibold">Global Academic & Industry Collaborations</p>
        </div>
        <div>
            <p class="text-4xl font-bold">12,000+</p>
            <p class="text-lg font-semibold">Proud and Successful Alumni Worldwide</p>
        </div>
        <div>
            <p class="text-4xl font-bold">170+</p>
            <p class="text-lg font-semibold">Highly Qualified & Experienced Faculty Members</p>
        </div>
    </div>
</section>

<section id="message" class="md:py-10 scroll-mt-24 aarni-font">
    <div class="max-w-7xl mx-auto p-6">
        <div class="grid grid-cols-1 md:grid-cols-3 items-start overflow-hidden">
            <div class="md:col-span-1 overflow-hidden relative">
                <div class="h-80">
                    <img src="assets/img/top-leadership/chancellor-arni.jpg" alt="Dr. Vivek Singh"
                         class="h-full w-full object-cover">
                    <div
                        class="bg-lime-500/90 absolute bottom-0 w-full text-white py-2 text-center text-sm font-semibold">
                        Dr. Vivek Singh
                    </div>
                </div>
            </div>
            <div class="p-6 border h-80 overflow-y-auto md:col-span-2 scrollbar-thin aarni-font">
                <h2 class="text-2xl md:text-3xl font-bold mb-4">
                    Chancellor, Arni University
                </h2>
                <p class="my-2 text-gray-800">
                    Greetings from Arni University!
                </p>
                <p class="my-2 text-gray-800 text-justify">
                    As the Chancellor of ARNI University, I am honored to lead an institution committed to academic
                    excellence, innovation, and holistic student development. At ARNI, our vision is to create a vibrant
                    learning ecosystem that empowers students to become thoughtful leaders, skilled professionals, and
                    responsible global citizens.
                    <br><br>
                    Recognized among the top universities in Himachal Pradesh, ARNI University is nestled in a
                    picturesque 120-acre green campus, offering a serene academic atmosphere with a panoramic view of
                    the majestic Dhauladhar ranges. This environment fosters not only academic growth but also personal
                    and cultural enrichment.
                    <br><br>
                    We offer cutting-edge infrastructure including smart classrooms, well-equipped engineering and
                    computer labs, modern seminar halls, a comprehensive library network with access to global
                    e-resources, and a fully Wi-Fi-enabled campus. Our diverse academic community is supported by
                    experienced faculty, strong placement initiatives, quality residential facilities for both boys and
                    girls, extensive sports and recreational amenities, an on-campus health center, and safe,
                    well-connected transportation services.
                    <br><br>
                    At ARNI University, we are deeply committed to nurturing talent and fostering innovation while
                    staying grounded in values. We warmly welcome students from across India and around the world to be
                    a part of our growing legacy.
                    <br><br>
                    Warm regards,
                    <br>
                    Dr. Vivek Singh
                    <br>
                    Chancellor
                    <br>
                    ARNI University
                </p>
            </div>
        </div>
    </div>
</section>

<!--<section id="tie-ups" class="scroll-mt-24 relative bg-gray-100 aarni-font">
    <div class="max-w-7xl mx-auto text-center p-6">
        <h2 class="text-2xl md:text-3xl font-bold mb-4">
            Global Academic Tie-Ups
        </h2>
        <p class="text-gray-800 my-4">
            Arni University is committed to fostering international partnerships that enrich our academic ecosystem and
            offer our students a truly global learning experience. Through strategic tie-ups with reputed institutions
            across the globe, we provide access to exchange programs, collaborative research, joint degree options, and
            culturally immersive experiences.
        </p>
        <div class="relative w-full max-w-6xl overflow-hidden">
            <div
                class="carousel-track flex transition-transform duration-300 ease-in-out"
                [style.transform]="'translateX(' + translateX + '%)'"
            >
                <div
                    *ngFor="let item of topTieUp"
                    class="w-full md:w-1/3 lg:w-1/4 px-2 shrink-0 "
                >
                    <div class="mx-auto bg-white h-full shadow-md overflow-hidden">
                        <div class="relative">
                            <div class="clip-diagonal">
                                <img [src]="item?.imageUrl" alt="University" class="w-full h-48 object-cover"/>
                            </div>
                            <div class="absolute -bottom-6 left-4 -translate-y-1/2 z-10">
                                <div
                                    class="bg-red-500 text-white text-xs font-semibold w-[60px] h-[60px] flex items-center justify-center rounded-full shadow">
                                    {{ item?.country }}
                                </div>
                            </div>
                        </div>
                        <div class="px-4 pt-6 pb-4 text-start text-ellipsis">
                            &lt;!&ndash;<img [src]="item?.logoUrl" alt="Logo" class="w-12 mb-2"/>&ndash;&gt;
                            <h3 class="text-lg font-semibold mb-1">{{ item?.name }}</h3>
                            <p class="text-sm text-gray-600">{{ item?.description | truncatewords:20 }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="absolute top-1/2 -translate-y-1/2 left-0">
                <button (click)="prev()" class="bg-white shadow p-2 rounded-full">
                    <i class="fa fa-chevron-left text-orange-600"></i>
                </button>
            </div>
            <div class="absolute top-1/2 -translate-y-1/2 right-0">
                <button (click)="next()" class="bg-white shadow p-2 rounded-full">
                    <i class="fa fa-chevron-right text-orange-600"></i>
                </button>
            </div>
        </div>
        <button class="bg-lime-500 hover:bg-lime-600 text-white px-6 py-2 rounded-full my-6 font-semibold transition">
            View All Tie-Ups
        </button>
    </div>
</section>-->

<section id="scholarship">
    <div class="max-w-7xl mx-auto p-6 aarni-font">
        <div class="grid md:grid-cols-2 items-center">
            <div class="">
                <img src="assets/img/international-why-choose-arni-scholarship.webp"
                    alt="Scholarship">
            </div>
            <div>
                <h2 class="text-2xl md:text-3xl font-bold mb-4">
                    Scholarship
                </h2>
                <p><strong>Scholarship Opportunities:</strong></p>
                <p class="text-gray-800 my-4 text-justify">
                    At ARNI University, we are committed to making quality education accessible to students worldwide.
                    We offer a range of scholarships and financial aid programs designed to support international
                    students in their academic pursuits.
                </p>
                <p class="text-gray-800 my-4 font-semibold">Key Highlights:</p>
                <ul class="list-disc text-gray-800 text-justify">
                    <li>Merit-Based Scholarships: Awarded to students demonstrating exceptional academic performance.
                    </li>
                    <li>Financial Assistance: Support for students facing economic challenges, ensuring that financial
                        constraints do not hinder educational aspirations.
                    </li>
                    <li>"Earn While You Learn" Program: Provides opportunities for students to work part-time within the
                        university, allowing them to gain experience and support their studies financially.
                    </li>
                </ul>
                <p class="text-gray-800 my-4 font-semibold">Our goal is to foster a diverse and inclusive academic
                    environment where international students can thrive.</p>
                <div class="mt-10">
                    <button [routerLink]="'/form/apply-form'"
                            class="bg-lime-500 hover:bg-lime-600 text-white px-6 py-2 rounded-full font-semibold transition">
                        Apply Now
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="how-to-apply" class="bg-[#1f3b8c] text-white px-6 py-8 aarni-font">
    <div class="max-w-6xl mx-auto text-center">
        <h2 class="text-2xl md:text-3xl font-bold mb-10">How To Apply</h2>
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-10 md:gap-0">
            <div class="flex relative flex-col items-center text-center z-10 w-full md:w-1/4 px-2">
                <div class="h-20">
                    <div class="bg-orange-400 w-20 h-20 flex items-center justify-center rounded-full mb-4">
                        <i class="fas fa-pen text-white text-2xl"></i>
                    </div>
                </div>
                <div class="h-10 pt-2 md:pt-4">
                    <p>Explore our courses, choose the program that aligns with your academic goals.</p>
                </div>
                <div class="absolute top-10 left-[60%] w-[100%] right-0 h-1 bg-orange-400 z-0 hidden md:block"></div>
            </div>

            <div class="flex flex-col items-center text-center relative z-10 w-full md:w-1/4 px-2">
                <div class="h-20">
                    <div class="bg-orange-400 w-20 h-20 flex items-center justify-center rounded-full mb-4">
                        <i class="fas fa-file-alt text-white text-2xl"></i>
                    </div>
                </div>
                <div class="h-10 pt-4">
                    <p>Fill in the online Application form & Upload Required Documents.</p>
                </div>
                <div class="absolute top-10 left-[60%] w-[100%] right-0 h-1 bg-orange-400 z-0 hidden md:block"></div>
            </div>

            <div class="flex flex-col items-center text-center relative z-10 w-full md:w-1/4 px-2">
                <div class="h-20">
                    <div class="bg-orange-400 w-20 h-20 flex items-center justify-center rounded-full mb-4">
                        <i class="fas fa-dollar-sign text-white text-2xl"></i>
                    </div>
                </div>
                <div class="h-10 pt-4">
                    <p>
                        Receive provisional admission with the fee and course details.
                    </p>
                </div>
                <div class="absolute top-10 left-[60%] w-[100%] right-0 h-1 bg-orange-400 z-0 hidden md:block"></div>
            </div>

            <div class="flex flex-col items-center text-center relative z-10 w-full md:w-1/4 px-2">
                <div class="h-20">
                    <div class="bg-orange-400 w-20 h-20 flex items-center justify-center rounded-full mb-4">
                        <span class="text-white text-xl font-bold">VISA</span>
                    </div>
                </div>
                <div class="h-10 pt-4">
                    <p>
                        Confirm admission, pay the fee, and apply for the visa.
                    </p>
                </div>
            </div>
        </div>

        <div class="mt-16">
            <button class="bg-lime-500 hover:bg-lime-600 text-white px-6 py-2 rounded-full font-semibold transition"
                    [routerLink]="'/form/apply-form'">
                Apply Now
            </button>
        </div>
    </div>
</section>

<section id="gallery" class="pt-5">
    <div class="mx-auto">
        <div class="grid grid-cols-12 items-center gap-2 px-2">
            <div
                class="col-span-12 md:col-span-8 border pt-28 h-full flex justify-end place-items-end overflow-hidden  bg-cover bg-center bg-[url(assets/img/events/event9.webp)]">
                <button
                    class=" bg-lime-500 hover:bg-lime-600 text-white px-6 py-2 m-4 rounded-full font-semibold transition"
                    [routerLink]="'/quick-links/image-gallery'">
                    View Images
                </button>
            </div>
            <div class="md:col-span-4 col-span-12 h-full">
                <div
                    class="md:col-span-8 border overflow-hidden py-56 bg-cover bg-top bg-[url(assets/img/home-page-events/image-3.webp)]">
                </div>
            </div>
        </div>
    </div>
</section>

<div id="recruiters" class="w-full aarni-font">
    <div class="bg-gray-50 text-center font-sans py-12">
        <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
        <div class="flex max-w-7xl mx-auto items-center relative justify-center gap-6 p-4">

            <div class="  mx-auto overflow-hidden ">
                <div class="slider overflow-hidden w-[100%]  whitespace-nowrap" #sliderTrack>
                    <div class="logo inline-block p-2 w-52 shadow bg-white mx-2 text-center rounded"
                         *ngFor="let logo of recruiters">
                        <img [src]="logo?.logo" alt="Logo" class="w-32 mx-auto"/>
                    </div>
                </div>
                <button
                    class=" absolute left-0 shadow md:-left-8 bg-white top-[25%] text-green-950 text-2xl hover:text-white hover:bg-green-900 transition duration-75 w-10 h-10 rounded-full"
                    (click)="scrollPrev()">‹
                </button>
                <button
                    class="absolute right-0 shadow md:-right-8 bg-white top-[25%] text-green-950 text-2xl hover:text-white hover:bg-green-900 transition duration-75 w-10 h-10 rounded-full"
                    (click)="scrollNext()">›
                </button>
            </div>
        </div>
        <!--<button class="bg-lime-500 hover:bg-lime-600 text-white px-6 py-2 rounded-full font-semibold transition">
            View all
        </button>-->
    </div>
</div>
